var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0301 0C26.2227 0 27.9999 1.59007 27.9999 3.55216V27.4478C27.9999 29.4099 26.2227 31 24.0301 31H4.54131C2.85222 31 1.42297 30.07 0.845667 28.7397C0.672264 28.3392 0.571289 27.9 0.571289 27.4478V3.55216C0.571289 1.59007 2.3484 0 4.54131 0L24.0301 0Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 11.6264C11.3984 13.053 10.1058 14.2098 8.51107 14.2098C6.91661 14.2098 5.62402 13.053 5.62402 11.6264C5.62402 10.1997 6.91661 9.04297 8.51107 9.04297C10.1058 9.04297 11.3984 10.1997 11.3984 11.6264Z",
    fill: "#22428F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 19.9439V27.4484C27.9999 29.4119 26.2244 31.0005 24.0301 31.0005H4.54135C2.85226 31.0005 1.42301 30.0706 0.845703 28.7402L17.5481 13.7955C18.5299 12.9171 20.1468 12.9171 21.1283 13.7955L27.9999 19.9439Z",
    fill: "url(#paint0_linear_4449_57071)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0338 30.9991H4.54132C2.85222 30.9991 1.42297 30.0692 0.845667 28.7388C0.672265 28.3384 0.571289 27.8992 0.571289 27.447V22.5259L5.27748 18.3151C6.25922 17.4366 7.87588 17.4366 8.85762 18.3151L23.0338 30.9991Z",
    fill: "url(#paint1_linear_4449_57071)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4449_57071",
    x1: 1.34374,
    y1: 18.6794,
    x2: 1.34374,
    y2: 35.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0874CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4449_57071",
    x1: -5.35807,
    y1: 10.6121,
    x2: -5.35807,
    y2: 30.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0874CF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file-upload-icon.2db50c9761fc81c998d53faf6737205b.svg";
export { ForwardRef as ReactComponent };